import { ReactNode } from 'react';
import './GenericChart.scss';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    TimeScale,
    PointElement,
    LineElement,
    Title,
    Legend,
    Filler,
    Tooltip,
    BarElement,
} from 'chart.js';
import 'chartjs-adapter-date-fns';
import classNames from 'classnames';

ChartJS.register(
    BarElement,
    CategoryScale,
    Filler,
    Legend,
    LineElement,
    LinearScale,
    PointElement,
    TimeScale,
    Title,
    Tooltip,
);

export interface GenericChartProps {
    data: Record<string, number>;
    title?: string;
    displayUnit?: string;
    showCurrentValue?: boolean;
}

export function GenericChart({
    title,
    children,
    currentValue,
    className,
}: {
    title?: string;
    children: ReactNode;
    currentValue?: ReactNode;
    className?: string;
}) {
    return (
        <>
            <label
                className={classNames('GenericChart__name', `${className}__name`)}
                data-testid={`${title}-Chart`}
            >
                {title}
            </label>

            {currentValue != null ? (
                <h5
                    className={classNames(
                        'GenericChart__current_value',
                        `${className}__current_value`,
                    )}
                >
                    {currentValue}
                </h5>
            ) : null}
            <div className={classNames('GenericChart', className)}>{children}</div>
        </>
    );
}
